module.exports = __webpack_public_path__ + "img/leaselink.bda278f.svg";